<template>
  <div class="pt-safe z-30 flex items-center py-4 px-safe bg-background/50 backdrop-blur-xl"
    :class="[appStore.plateform]">
    <div ref="container"
      class="relative leading-icon mr-6 rounded-full h-10 w-10 flex justify-center items-center"
      v-if="$slots.leadingicon" @click="clickTrigger">
      <PressedIndicator ref="indicator" :id="uniqId"
        @finished="emits('leading-icon-click')" color="secondary" />
      <slot name="leadingicon">
        <ArrowLeftIcon class="h-6 w-6 cursor-pointer" @click="router.back()" />
      </slot>
    </div>
    <div class="headline mr-6 grow">
      <h1 class="text-lg font-bold">
        <slot name="headline" />
      </h1>
    </div>

    <div class="trailingicon" v-if="$slots.trailingicon">
      <slot name="trailingicon"></slot>
    </div>

    <ProgressBar v-if="appStore.barSteps > 0"
      :current="appStore.pageLoadingProgress" ref="progressBar"
      class="absolute z-50 bottom-0 left-0 right-0" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router';
import { ArrowLeftIcon } from '@heroicons/vue/24/outline';
import PressedIndicator from '../PressedIndicator.vue';
import eventBus from '../../eventbus';
import ProgressBar from '../ProgressBar.vue';
import { useAppSettingsStore } from '../../stores/AppSettingsStore';
const router = useRouter();
const appStore = useAppSettingsStore();
const uniqId = crypto.randomUUID();
const container = ref<HTMLElement | null>(null);

const emits = defineEmits<{
  (e: "click"): void
  (e: "leading-icon-click"): void
}>()

const clickTrigger = (e: any) => {
  const eb = {
    container: container.value,
    event: e
  }
  eventBus[uniqId] = eb;
}

</script>